import React, { Component } from "react"

/* Cubago ep-ui */
import { Background, Balance, Internet, InactionTiming, GameInfo, Transactions, Error } from "@cuba-go/ep-ui"

/* Widgets */
import { PlayerCards, DealerCards, Rates, Chips, PokerResult, Preloader, InsuranceChips, Purchase } from './widgets'

/* Components */
import { Fold, Bet, Start, Payout, Picture, Sixth, Exchange, Insurance, Notification } from './components'

/* Socket IO */
import { io } from "socket.io-client"

/* JWT */
import { decodeToken } from 'react-jwt'

/* REST API */
import { history } from './api/History'

/* Constants */
import { env, utils, sound } from "./constants"
import { ERROR, CHOICE, GAME, LOADING } from "./constants/status"

/* Rules */
import { rules } from "./constants/rules"

/* Redux */
import { connect } from 'react-redux'

/* Fields */
const BOXES = [0, 1]
const pathname = window.location.search
const token = pathname.length > 1 ? pathname.substring(1) : ""
const imgUrl = 'https://repb.rekopgames.com/images/rules/game.png'

/* Entry Point */
class App extends Component {

    constructor(props) {
        super(props)

        const data = decodeToken(token)

        this.state = {
            status: LOADING,

            ante: [0, 0],
            bonus: [0, 0],
            selected: 0,
            last: [{ ante: 0, bonus: 0 }, { ante: 0, bonus: 0 }],
            bet: [0, 0],
            list: [],
            balance: 0,
            total: 0,
            lastWin: 0,

            solution: ["", ""],
            used: [false, false],

            playerCards: [[], []],
            playerGame: [null, null],
            sixthGame: [[], []],
            exchanged: [[], []],
            isExchange: [false, false],

            dealerCards: [],
            dealerGame: null,

            result: [null, null],
            bonusResult: [null, null],
            chip: [false, false],

            insurance: [0, 0],
            insuranceStatus: [0, 0],
            insuranceModal: [false, false],

            isPurchase: [false, false],
            purchase: [null, null],
            removedCard: null,

            gameInfo: null,
            transactions: [],
            operations: [],
            histories: [],
            historyLoading: true,
            historyPage: 1,
            historyHasMore: true,

            /* Game Session */
            closed: false,
            newDevice: false,
            isDisconnected: false,

            currency: data.currency,
            chips: utils.getChips(data.chips),
            game: {
                max: data.max,
                maxBonus: data.maxBonus,
                min: data.min,
                maxPay: data.maxPay
            },

            operator: data.operator,

            volume: false,
            locale: data.locale ? data.locale : "ru",
            isDemo: data.isDemo
        }

        const { setLanguage } = this.props
        setLanguage(data.locale ? data.locale : "ru")

        /* Start connection */
        this.socket = io(env.endpoint, { auth: { token: `${token}`, reconnection: false, isPlayer: true } })
    }

    componentDidMount = () => {
        this.game()
        this.loadHistory()
    }

    /* Load History */
    loadHistory = (page = 1) => {

        const { histories } = this.state

        if (page > 1) {
            this.setState({ historyPage: page })
        }

        history(token, page).then(response => {
            if (response.status === 200) {
                let list = response.data

                if (page > 1) {
                    list = [...histories, ...response.data]
                }

                if (response.data.length < 5) {
                    this.setState({ historyHasMore: false })
                }

                this.setState({ histories: list, historyLoading: false })
            }
        }).catch(() => {
            this.setState({ histories: [], historyLoading: false })
        })
    }


    game = () => {
        /* On error */
        this.socket.on("connect_error", () => {
            const timer = setTimeout(() => {
                this.setState({ status: ERROR })
                clearTimeout(timer)
            }, 1000)

        })

        /*  */
        this.socket.on("disconnect", () => {
            this.setState({ isDisconnected: true })
        })

        /* On connect */
        this.socket.on("connect", () => {
            const timer = setTimeout(() => {
                if (this.state.status !== CHOICE) {
                    this.setState({ status: CHOICE })
                    this.clear()
                }
                clearTimeout(timer)
            }, 2000)
        })

        /* On New Device */
        this.socket.on("newDeviceConnection", () => {
            this.setState({ newDevice: true })
            this.socket.disconnect()
        })


        /* Reconnection */
        this.socket.on("reconnection", data => {

            const time = data.transactionError ? 3500 : 2000

            if (data.transactionError) {
                utils.toggleError(utils.translate("Transaction error"))
            }

            if (data.error) {
                utils.toggleError(utils.translate("Something went wrong! Try again later or refresh the page."))
            }

            setTimeout(() => {
                this.setState({
                    status: data.status,
                    gameInfo: data.gameInfo,
                    ante: data.ante,
                    bonus: data.bonus,
                    total: data.total,
                    bet: data.bet,
                    used: data.used,
                    playerCards: data.playerCards,
                    exchanged: data.exchanged,
                    dealerCards: data.dealerCards,
                    playerGame: data.playerGame,
                    sixthGame: data.sixthGame,
                    dealerGame: data.dealerGame,
                    bonusResult: data.bonusResult,
                    result: data.result,
                    transactions: data.transactions,

                    solution: data.solution,
                    isExchange: data.isExchange,
                    removedCard: data.removedCard,

                    insurance: data.insurance,
                    insuranceStatus: data.insuranceStatus,

                    isPurchase: data.isPurchase,
                    purchase: data.purchase,

                })
            }, time)
        })

        /* On start */
        this.socket.on("status", data => {
            const { status } = this.state
            if (data !== status) {
                this.setState({ status: data })
            }

            if (data === CHOICE) {
                this.clear()
                this.loadHistory()
            }
        })


        /* Balance */
        this.socket.on("balance", data => {
            this.setState({ balance: data })
        })


        /* Get Insurance Status */
        this.socket.on("insuranceStatus", ({ box, status }) => {

            const { volume, insuranceStatus } = this.state

            if (status === "win") {
                if (volume) {
                    sound.play('winsmall', 0.2)
                }
            }

            insuranceStatus[box] = status

            this.setState({ insuranceStatus })
        })

        /* Get a dealer card */
        this.socket.on("dealer", data => {

            const { card } = data

            if (card) {

                const { dealerCards, volume } = this.state
                const i = dealerCards.findIndex(e => e.uuid === card.uuid)
                let cards = dealerCards

                if (i === -1) {
                    cards.push(card)
                    this.setState({ dealerCards: cards })

                    if (volume) {
                        sound.play('card', 0.2)
                    }
                }
                else if (dealerCards[i].id && i !== 4) {
                    let current = dealerCards[i]
                    cards.splice(i, 1)
                    cards.push(current)
                    this.setState({ dealerCards: cards })
                }
            }

        })

        this.socket.on("dealerData", data => {

            const { result } = this.state
            const { box } = data

            const { volume } = this.state
            result[box] = data.result

            this.setState({ dealerCards: data.dealerCards, dealerGame: data.dealerGame, result })

            if (data.result && (data.result.result === "win" || data.result.result === "draw")) {
                if (volume) {
                    sound.play('win', 0.2)
                }
            }
        })

        /* Get a Player card */
        this.socket.on("player", data => {

            const { card, box } = data
            const { playerCards, volume } = this.state

            if (card && playerCards[box]) {

                const i = playerCards[box].findIndex(e => e.uuid === card.uuid)

                if (i === -1) {

                    let cards = playerCards
                    cards[box].push(card)

                    this.setState({ playerCards: cards })

                    if (volume) {
                        sound.play('card', 0.2)
                    }
                }

            }
        })

        this.socket.on("playerGame", ({ box, hand, exchange, reconnect }) => {

            const { playerGame, solution } = this.state

            playerGame[box] = hand
            this.setState({ playerGame, status: GAME })

            if (exchange && !reconnect) {
                solution[box] = ""
                this.setState({ solution })
            }

        })


        this.socket.on("reconnectedPlayerGame", ({ box, hand }) => {

            const { playerGame, used } = this.state

            if (!playerGame[box] && !used[box]) {
                playerGame[box] = hand
                this.setState({ playerGame, status: GAME })
            }
        })


        /* SIXTH GAME */
        this.socket.on("sixthGame", ({ box, hand, reconnect }) => {

            const { sixthGame, solution } = this.state

            sixthGame[box] = hand
            this.setState({ sixthGame, solution, status: GAME })

            if (!reconnect) {
                solution[box] = ""
                this.setState({ solution })
            }
        })


        /* Result */
        this.socket.on("bonusResult", data => {

            const { result, box } = data
            const { bonusResult, volume } = this.state

            if (!bonusResult[box] && result) {

                bonusResult[box] = result
                this.setState({ bonusResult })

                if (result.result === "win") {
                    if (volume) {
                        sound.play('winsmall', 0.2)
                    }
                }
            }

        })

        /* Purchase Card */
        this.socket.on("purchase", ({ removedCard, dealerCards, dealerGame, box }) => {
            const { isPurchase, solution } = this.state
            isPurchase[box] = true
            solution[box] = ""
            this.setState({ isPurchase, removedCard, dealerCards, dealerGame, solution })
        })

        /* Get Game Info */
        this.socket.on("gameInfo", data => {
            this.setState({ gameInfo: data })
        })

        /* Get transactions list */
        this.socket.on("transaction", data => {
            if (data.id) {
                const { operations } = this.state

                if (data.type === "credit") {
                    const timer = setTimeout(() => {
                        this.setState({ lastWin: this.state.lastWin + parseFloat(data.total) })
                        clearTimeout(timer)
                    }, parseInt(data.box) * 1000)
                }

                operations.push(data)
                this.setState({ operations })
            }
        })

        this.socket.on("editTransaction", data => {
            const { operations } = this.state
            let list = operations
            const index = list.findIndex(e => e.number === data.number)
            if (index > -1) {
                list[index].status = data.status
                this.setState({ operations: list })
            }
        })


        /* Force End Game */
        this.socket.on("forceEnd", () => {
            this.setState({ status: CHOICE })
            this.loadHistory()
            this.clear()
            utils.toggleError(utils.translate("The game ended due to the administrator's initiative"), "warning")
        })

        /* Notification From Admin */
        this.socket.on("adminNotification", data => {
            if (data && data.title && data.total && data.currency) {
                utils.toggleError(`${utils.translate(data.title)} ${utils.getWithCurrency(data.total, data.currency)}`, "success")
                this.loadHistory()
            }
        })

    }

    /* Disconnect user when inaction timer equal to 0 */
    setInactionState = () => {
        this.setState({ closed: true })
        this.socket.disconnect()
        this.clear()
    }

    /* Reser top timing */
    resetTimer = () => {
        if (this._inaction) {
            this._inaction.reset()
        }
    }

    handleClose = (id) => {

        const { showInternetConnectionError } = this.state

        if (id === "internet" && showInternetConnectionError <= 2) {
            this.setState({ showInternetConnectionError: showInternetConnectionError + 1 })
            if (showInternetConnectionError + 1 === 2) {
                setTimeout(() => {
                    this.setState({ showInternetConnectionError: 1 })
                }, 300000)
            }
        }

    }

    /* Check internet speed */
    checkInternetSpeed = (speed) => {

        const { showInternetConnectionError } = this.state

        if (showInternetConnectionError < 2) {
            if (parseInt(speed) < 3) {
                utils.toggleError(utils.translate("Poor internet connection"), "warning", "internet", this.handleClose)
            }
            else {
                utils.toastDismiss('internet')
            }
        }

    }

    clear = () => {
        this.setState({

            ante: [0, 0],
            bonus: [0, 0],
            bet: [0, 0],
            total: 0,
            list: [],

            gameInfo: null,

            solution: ["", ""],
            used: [false, false],

            playerCards: [[], []],
            playerGame: [],

            sixthGame: [[], []],
            exchanged: [[], []],
            isExchange: [false, false],

            dealerCards: [],
            dealerGame: null,

            insurance: [0, 0],
            insuranceStatus: [0, 0],
            insuranceModal: [false, false],

            isPurchase: [false, false],
            purchase: [null, null],
            removedCard: null,

            result: [],
            bonusResult: [],
            operations: []
        })
    }

    /* STAKE RATE */
    setStake = (data) => {

        const { ante, bonus } = data

        let total = 0

        ante.forEach(item => {
            if (item) {
                total += item
            }
        })

        bonus.forEach(item => {
            if (item) {
                total += item
            }
        })

        this.setState({ ante, bonus, total, lastWin: 0 })
        this.resetTimer()
    }


    /* Set exchanged action */
    setExchanged = (box, data) => {
        const { exchanged } = this.state
        exchanged[box] = data
        this.setState({ exchanged })
    }

    /* START ACTION */
    start = () => {

        const { ante, bonus } = this.state

        let stake = []
        ante.forEach((item, index) => {
            if (item) {
                stake.push({ ante: item, bonus: utils.check(bonus[index], 0) })
            }
            else {
                stake.push({ ante: 0, bonus: 0 })
            }
        })

        if (utils.valueLength(ante) > 0) {
            this.setState({ status: "DEALING", last: stake })
            this.socket.emit('start', { ante, bonus })
        }

        this.resetTimer()
    }


    /* FOLD ACTION */
    fold = box => {

        const { dealerCards, solution, insuranceModal, isExchange } = this.state

        if (dealerCards.length === 5 && solution[box] !== "BET" && solution[box] !== "FOLD") {
            this.socket.emit("pass", box)
            solution[box] = "FOLD"
            insuranceModal[box] = false

            if (!isExchange[box]) {
                this.setExchanged(box, [])
            }

            this.setState({ solution, insuranceModal })
        }

        this.resetTimer()
    }

    /* BET ACTION */
    bet = box => {

        const { dealerCards, ante, bet, total, solution, isExchange, insuranceModal, volume } = this.state

        if (dealerCards.length === 5 && solution[box] !== "BET" && solution[box] !== "FOLD") {

            this.socket.emit("bet", box)
            solution[box] = "BET"
            const value = ante[box] * 2
            bet[box] = value
            insuranceModal[box] = false

            if (!isExchange[box]) {
                this.setExchanged(box, [])
            }

            this.setState({ solution, bet, insuranceModal, total: total + value })

            /* Play sound */
            if (volume) {
                sound.play('sound', 0.2)
            }

            this.resetTimer()
        }

    }


    /* SIXTH ACTION */
    sixth = box => {

        const { playerCards, playerGame, solution, used, chip, ante, total, volume, insuranceModal } = this.state

        if (playerCards[box].length === 5 && !used[box]) {

            this.socket.emit("sixth", { box })
            solution[box] = "SIXTH"
            chip[box] = true
            used[box] = true
            playerGame[box].data = []
            insuranceModal[box] = false

            const value = ante[box]

            this.setState({ solution, chip, used, playerGame, insuranceModal, total: total + value })

            const timer = setTimeout(() => {
                const data = this.state.chip
                data[box] = false
                this.setState({ chip: data })
                clearTimeout(timer)
            }, 2000)

            if (volume) {
                sound.play('sound', 0.2)
            }

            this.resetTimer()
        }
    }

    /* EXCHANGE ACTION */
    exchange = box => {

        const { playerCards, playerGame, solution, used, chip, ante, total, volume, exchanged, isExchange, insuranceModal } = this.state

        if (playerCards[box].length === 5 && !used[box]) {

            if (exchanged[box].length === 1) {
                utils.toggleError(utils.translate("You must select 2 or more cards"), "error", "exchange")
                return
            }

            this.socket.emit("exchange", { box, exchanged: exchanged[box] })
            solution[box] = "EXCHANGE"
            chip[box] = true
            isExchange[box] = true
            used[box] = true
            playerGame[box] = null
            insuranceModal[box] = false

            this.setState({ solution, chip, isExchange, used, playerGame, insuranceModal, total: total + ante[box] })

            /* CANCEL CHIP ANIMATION */
            const timer = setTimeout(() => {
                const data = this.state.chip
                data[box] = false
                this.setState({ chip: data })
                clearTimeout(timer)
            }, 2000)

            /* Play sound */
            if (volume) {
                sound.play('sound', 0.2)
            }

            this.resetTimer()
        }
    }


    /* Insurance */
    insurance = (value, box) => {

        const { total, insurance, insuranceModal } = this.state
        insurance[box] = parseFloat(value)
        insuranceModal[box] = false

        this.setState({ insurance, insuranceModal, total: total + parseFloat(value) })

        this.socket.emit("insurance", { box, insurance: parseFloat(value) })

        this.resetTimer()
    }

    /* Purchase */
    setPurchase = (box, value) => {

        const { balance, ante, total, volume, isPurchase, purchase, solution } = this.state

        if (parseInt(balance) < parseInt(ante[box])) {
            utils.toggleError(utils.translate("You don't have enough funds"), "error", "nomoney")
            return
        }

        solution[box] = "PURCHASE"
        isPurchase[box] = false
        purchase[box] = value

        this.setState({ isPurchase, purchase, total: total + ante[box] })

        this.socket.emit("purchase", { box, data: value })

        if (volume) {
            sound.play('sound', 0.2)
        }

        this.resetTimer()

    }

    /* Show Insurance */
    toggleInsurance = (box, value) => {
        const { insuranceModal } = this.state
        insuranceModal[box] = value
        this.setState({ insuranceModal })
    }

    /* Game action */
    gameAction = (action) => {
        this.socket.emit("gameAction", action)
    }

    /* Draw Button */
    _buttons = box => {

        const { status, playerCards, dealerCards, solution, playerGame, sixthGame, used, exchanged, isExchange, insurance, isPurchase, purchase } = this.state

        const game = sixthGame[box] && sixthGame[box].length > 0 ? sixthGame[box][0] : playerGame[box]
        const isInsurance = game && game.level >= 4
        const full = used[box] && !isInsurance && insurance[box] === 0 ? "full-buttons-box" : ""

        if (status === "GAME" && dealerCards.length === 5 && playerCards[box].length >= 5 && solution[box] === "" && !isPurchase[box] && !purchase[box]) {
            return (
                <div className={`buttons-box box-${box} ${full}`}>
                    {insurance[box] === 0 && <Fold onClick={() => this.fold(box)} />}
                    <Bet onClick={() => this.bet(box)} />
                    {!used[box] && exchanged[box].length === 0 && !isExchange[box] && <Sixth isInsurance={isInsurance && insurance[box] === 0} onClick={() => this.sixth(box)} />}
                    {!used[box] && exchanged[box].length > 0 && !isExchange[box] && <Exchange isInsurance={isInsurance && insurance[box] === 0} onClick={() => this.exchange(box)} />}
                    {isInsurance && insurance[box] === 0 && <Insurance onClick={() => this.toggleInsurance(box, true)} />}
                </div>
            )
        }
    }

    /* Draw Start Button */
    _start = () => {

        const { ante, status } = this.state

        if (status === "CHOICE") {
            return (
                <div className="start-button-box">
                    <Start onClick={() => this.start()} ante={ante} />
                </div>
            )
        }

    }

    /* Box Result */
    renderResult = (box) => {
        const { result, currency } = this.state
        return <PokerResult key={`${box}`} box={box} result={result[box]} currency={currency} />
    }

    /* Draw Content */
    _content = () => {

        /* Fields */
        const { status, ante, bonus, selected, last, list, playerCards, playerGame, sixthGame, used, exchanged, isExchange, dealerCards, dealerGame, solution, balance, game, chips, currency, volume, result, bonusResult, bet, chip, insurance, insuranceStatus, insuranceModal, isPurchase, purchase, removedCard } = this.state

        const style = utils.valueLength(ante) === 1 && status !== CHOICE ? "one-box" : ""

        return (
            <div className="content">

                <div className={`game ${style} ${status !== "CHOICE" ? "visible" : "hidden"}`}>

                    <DealerCards
                        cards={dealerCards}
                        game={dealerGame}
                        removedCard={removedCard}
                    />

                    <div className={`box-container ${style} ${status === "CHOICE" ? "bottom" : "default"}`}>
                        {BOXES.map(box => {
                            if (status === CHOICE || ante[box]) {
                                return (
                                    <div className="box" key={`${box}`}>

                                        <PlayerCards
                                            box={box}
                                            ante={ante[box]}
                                            status={status}
                                            cards={playerCards[box]}
                                            game={playerGame[box]}
                                            sixthGame={sixthGame[box]}
                                            solution={solution[box]}
                                            used={used[box]}
                                            exchanged={exchanged[box]}
                                            isExchange={isExchange[box]}
                                            setExchanged={exchanged => this.setExchanged(box, exchanged)}
                                            volume={volume}
                                            renderResult={() => this.renderResult(box)}
                                        />

                                        <Rates
                                            box={box}
                                            chips={chips}
                                            status={status}
                                            ante={ante[box]}
                                            bonus={bonus[box]}
                                            result={result[box]}
                                            bonusResult={bonusResult[box]}
                                            bet={bet[box]}
                                            setStake={data => this.setStake(data)}
                                            selected={selected}
                                            list={list}
                                            setList={list => this.setState({ list })}
                                            solution={solution[box]}
                                            balance={balance}
                                            chip={chip[box]}
                                            bottomBet={() => this.bet(box)}
                                            game={game}
                                            currency={currency}
                                            volume={volume}
                                            insurance={insurance[box]}
                                            insuranceStatus={insuranceStatus[box]}
                                            all={{ ante, bonus }}
                                        />

                                        {this._buttons(box)}

                                        {insuranceModal[box] &&
                                            <InsuranceChips
                                                chips={chips}
                                                insuranceModal={insuranceModal[box]}
                                                close={() => this.toggleInsurance(box, false)}
                                                setInsurance={value => this.insurance(value, box)}
                                                ante={ante[box]}
                                                balance={balance}
                                                playerGame={playerGame[box]}
                                                sixthGame={sixthGame[box]}
                                                maxPay={game.maxPay}
                                            />
                                        }

                                        {isPurchase[box] &&
                                            <Purchase
                                                isPurchase={isPurchase[box]}
                                                purchase={purchase[box]}
                                                setPurchase={(value) => this.setPurchase(box, value)}
                                            />
                                        }

                                    </div>
                                )
                            }
                            return null
                        }
                        )}
                    </div>

                    {this._start()}

                </div>

                <div className={`choice ${status === "CHOICE" ? "visible" : "hidden"}`}>
                    <Chips
                        box={0}
                        chips={chips}
                        ante={ante}
                        bonus={bonus}
                        setStake={data => this.setStake(data)}
                        last={last}
                        selected={selected}
                        setSelected={selected => this.setState({ selected })}
                        list={list}
                        setList={list => this.setState({ list })}
                        balance={balance}
                        game={game}
                        currency={currency}
                        volume={volume}
                    />
                </div>

            </div>
        )
    }


    /* Get Rules */
    getRules = () => {

        const { language } = this.props

        if (rules[language]) {
            return rules[language]
        }

        return rules["ru"]
    }

    render = () => {

        const { status, balance, total, lastWin, currency, game, histories, historyHasMore, historyPage, operations, closed, newDevice, isDisconnected, gameInfo, volume, locale, operator, isDemo } = this.state
        const { language, setLanguage } = this.props

        const logo = operator !== "makao" ? "cubago.png" : "makao.png"
        const payout = <Payout game={game} currency={currency} />
        const historyData = { histories, historyHasMore }
        const params = { mediapoint: `${env.mediapoint}`, type: "two-box", lang: locale, operator, isDemo }

        if (status === LOADING) {
            return <Preloader operator={operator} />
        }

        if (status === ERROR || newDevice || closed || isDisconnected) {
            return <Error newDevice={newDevice} closed={closed} isDisconnected={isDisconnected} params={params} />
        }

        return (
            <Background params={params} language={language} setLanguage={language => setLanguage(language)} historyData={historyData} payout={payout} gameInfo={gameInfo} rules={this.getRules()} loadMore={() => this.loadHistory(historyPage + 1)} openBalance={() => this.gameAction("openDepositModal")} volume={volume} setVolume={volume => this.setState({ volume })}>
                <div className="app">

                    <InactionTiming time={240} ref={ref => this._inaction = ref} setInactionState={() => this.setInactionState()} />

                    <GameInfo title="QUEEN OF SPADES" game={game} currency={currency} payout={payout} params={params} close={() => this.gameAction("closeGame")} />
                    <Balance status={status} balance={balance} total={total} lastWin={lastWin} currency={currency} params={params} openBalance={() => this.gameAction("openDepositModal")} />
                    <Transactions info={gameInfo} operations={operations} currency={currency} params={params} />

                    {this._content()}

                    <div className="back-outer">
                        <div className="background" />
                        <div className="glass" />
                        <div className="shadow" />
                    </div>

                    <div className={`makao ${(status === CHOICE) ? 'visible' : 'hidden'}`}>
                        <Picture src={`${env.mediapoint}/images/${logo}`} alt="Makao" />
                    </div>

                    <Notification />

                    <Internet url={imgUrl} setInternetSpeed={data => this.checkInternetSpeed(data)} />

                </div>
            </Background>
        )
    }

}
const mapStateToProps = state => {
    return {
        language: state.language
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setLanguage: data => dispatch({ type: 'SET_LANGUAGE', payload: data })
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(App)